import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant, FIELD_COMPONENT, MODULE_NAME, PERIOD } from 'app/config/constants';
import { DialogMessageComponent } from 'app/dialog/dialog-message/dialog-message.component';
import { Common } from 'app/model/entity/common';
import { ApplicationDTO } from 'app/model/entity/ticket-editor/dto/application-DTO';
import { CommonService } from 'app/service/common.service';
import { DialogService } from 'app/service/dialog.service';
import { MenuActionService } from 'app/service/menu-action.service';
import { TicketManagerService } from 'app/service/ticket-manager.service';
import { saveAs } from 'file-saver';
import _ from 'lodash';
import moment from 'moment';
import { DatePickerDirective } from 'ng2-date-picker';
import { Subscription } from 'rxjs';
@Component({
  selector: 'tab-report',
  templateUrl: './tab-report.component.html',
  styleUrls: ['./tab-report.component.scss']
})
export class TabReportComponent implements OnInit {
  @Input() tabSelected: number; // tab selected
  @Input() listApp: ApplicationDTO[]; // list Application
  Constant = Constant;
  MODULE_NAME = MODULE_NAME;
  FIELD_COMPONENT = FIELD_COMPONENT;
  /**
   * common
   */
  PERIOD = PERIOD;

  /**
   * array subscription
   */
  subscriptions: Array<Subscription> = new Array<Subscription>();

  /**
   * common object
   */
  private commonObject: Common;

  /**
   * language key
   */
  public languageKey: string;

  /**
   * object
   */
  period: number = PERIOD.DAILY;

  /**
   * payloadForm
   */
  public payloadForm: FormGroup;
  /**
   * Config for datepicker
   */
  config: any;

  constructor(
    private translateService: TranslateService,
    private commonService: CommonService,
    private menuActionService: MenuActionService,
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ticketManagerService: TicketManagerService
  ) {
    // Action menu
    this.subscriptions.push(
      // Clear setting
      this.menuActionService.actionClearSetting.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.TicketManagerComponent] && this.tabSelected == Constant.REPORT_ENUM) {
          this.clearSearch();
        }
      }),
      // Returns the currently displayed language
      this.translateService.onLangChange.subscribe(() => {
        this.languageKey = this.commonService.getCommonObject().setting?.language;
        this.config = {
          showWeekNumbers: false,
          format: 'YYYY-MM-DD',
          firstDayOfWeek: 'mo',
          unSelectOnClick: false,
          locale: Helper.getLocale(this.languageKey)
        };
      })
    );

    this.payloadForm = this.formBuilder.group({
      appId: [-1],
      startDate: [],
      endDate: []
    });

    this.commonObject = this.commonService.getCommonObject();
  }

  ngOnInit(): void {
    this.languageKey = this.commonObject?.setting?.language;
    this.config = {
      showWeekNumbers: false,
      format: 'YYYY-MM-DD',
      firstDayOfWeek: 'mo',
      unSelectOnClick: false,
      locale: Helper.getLocale(this.languageKey)
    };
  }

  /**
   * open date picker
   * @param picker
   * @param time
   */
  openDatePicker(picker: DatePickerDirective, time: any): void {
    picker.api.open();
    this.addPseudoSpan();
    picker.api.moveCalendarTo(time ?? moment());
  }

  /**
   * add element date picker
   */
  addPseudoSpan(): void {
    while (document.getElementById('span-new')) {
      document.getElementById('span-new').remove();
    }
    return;
  }

  /**
   * Clear search
   */
  clearSearch() {
    this.payloadForm.patchValue({
      appId: '',
      startDate: '',
      endDate: ''
    });
  }

  /**
   * getDetailItem
   */
  getDetailItem(): void {
    if (this.checkValidateBeforeGetApi()) {
      let payload = {
        appId: this.payloadForm.value.appId,
        startDate: this.payloadForm.value.startDate,
        endDate: this.payloadForm.value.endDate,
        status: ''
      };
      this.ticketManagerService.getItemList(payload).subscribe(response => {
        const contentDispositionHeader = decodeURIComponent(response.headers.get('Content-Disposition'));
        const fileName = contentDispositionHeader?.split("filename*=UTF-8''")[1]
          ? contentDispositionHeader?.split("filename*=UTF-8''")[1]
          : 'DetailItem.csv';
        const file = new File([response.body], fileName, {
          type: 'text/csv'
        });
        saveAs(file);
      });
    }
  }

  /**
   * getDetailPlanTicket
   */
  getDetailPlanTicket(): void {
    if (this.checkValidateBeforeGetApi()) {
      let payload = {
        appId: this.payloadForm.value.appId,
        startDate: this.payloadForm.value.startDate,
        endDate: this.payloadForm.value.endDate
      };
      this.ticketManagerService.getPlanTicket(payload).subscribe(response => {
        const contentDispositionHeader = decodeURIComponent(response.headers.get('Content-Disposition'));
        const fileName = contentDispositionHeader?.split("filename*=UTF-8''")[1]
          ? contentDispositionHeader?.split("filename*=UTF-8''")[1]
          : 'DetailPlanTicket.csv';
        const file = new File([response.body], fileName, {
          type: 'text/csv'
        });
        saveAs(file);
      });
    }
  }

  /**
   * getDetailCouponTicket
   */
  getDetailCouponTicket(): void {
    if (this.checkValidateBeforeGetApi()) {
      let payload = {
        appId: this.payloadForm.value.appId,
        startDate: this.payloadForm.value.startDate,
        endDate: this.payloadForm.value.endDate
      };
      this.ticketManagerService.getCouponTicket(payload).subscribe(response => {
        const contentDispositionHeader = decodeURIComponent(response.headers.get('Content-Disposition'));
        const fileName = contentDispositionHeader?.split("filename*=UTF-8''")[1]
          ? contentDispositionHeader?.split("filename*=UTF-8''")[1]
          : 'DetailCouponTicket.csv';
        const file = new File([response.body], fileName, {
          type: 'text/csv'
        });
        saveAs(file);
      });
    }
  }

  /**
   * checkValidateBeforeGetApi
   * @returns
   */
  checkValidateBeforeGetApi(): boolean {
    const startDate = this.payloadForm.get('startDate').value;
    const endDate = this.payloadForm.get('endDate').value;
    if (!startDate) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('ticket-manager.tab-report.validate-startDate')
        }
      });
      return;
    } else if (moment(endDate).diff(moment(startDate), 'days') < 1 || moment(endDate).diff(moment(startDate), 'days') > 31) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('ticket-manager.tab-report.validate-endDate')
        }
      });
      return;
    }
    return true;
  }

  /**
   * Get name app display
   * @param value nameApp
   * @returns
   */
  changeDisplay(value: String): String {
    let temp = _.cloneDeep(value).toString();
    if (temp?.split('W')?.length > 10 && temp.length > 28) {
      value = value.substring(0, 28) + '...';
    } else if (value.length > 50) {
      value = value.substring(0, 50) + '...';
    }
    return value;
  }
}
